$(document).ready(function () {
  const APP_URL = "https://images.okepas.com";
  const apiUrl = APP_URL + "/api/discarded/list";
  let currentPage = 1;
  const limit = 10;
  let editingImageId = null;

  function renderPagination(totalPages) {
    const pagination = $("#pagination");
    pagination.empty();

    if (totalPages <= 1) return;

    let controls = `<ul class="custom-pagination">`;

    if (currentPage > 1) {
      controls += `<li data-page="${currentPage - 1}">Previous</li>`;
    }

    for (let i = 1; i <= totalPages; i++) {
      let activeClass = currentPage === i ? "active" : "";
      controls += `<li class="${activeClass}" data-page="${i}">${i}</li>`;
    }

    if (currentPage < totalPages) {
      controls += `<li data-page="${currentPage + 1}">Next</li>`;
    }

    controls += `</ul>`;
    pagination.append(controls);
  }

  function fetchDiscardedImages(page = 1) {
    $.get(`${apiUrl}?page=${page}&limit=${limit}`, function (res) {
      const container = $("#discarded-images-container");
      container.empty();

      const tbody = $("#discardedImagesTable");
      tbody.empty();

      if (!res.data || res.data.length === 0) {
        container.append('<p class="text-center w-100">No discarded images found.</p>');
        $("#pagination").empty();
        return;
      }

      res.data.forEach((item, index) => {
        const row = `
          <tr data-id="${item.id}">
            <td>${(page - 1) * limit + index + 1}</td>
            <td><img src="${item.image_src}" width="120" class="img-thumbnail" /></td>
            <td class="discard-comment">${item.reason}</td>
            <td>
              <button class="btn btn-sm btn-outline-primary edit-comment" data-id="${item.id}">Edit</button>
              <button class="btn btn-sm btn-outline-danger delete-discard" data-id="${item.id}">Delete</button>
            </td>
          </tr>`;
        tbody.append(row);
      });

      renderPagination(res.pagination.totalPages);
    });
  }

  fetchDiscardedImages(currentPage);

  $(document).on("click", ".custom-pagination li", function () {
    const selectedPage = parseInt($(this).data("page"));
    if (!isNaN(selectedPage) && selectedPage !== currentPage) {
      currentPage = selectedPage;
      fetchDiscardedImages(currentPage);
    }
  });

  // Open modal on Edit
  $(document).on('click', '.edit-comment', function () {
    editingImageId = $(this).data('id');
    const currentReason = $(`tr[data-id="${editingImageId}"] .discard-comment`).text().trim();
    $('#hideComment').val(currentReason);
    $('#hideModal').show();
  });

  // Submit modal update
  $('#submitHide').on('click', function () {
    const reason = $('#hideComment').val().trim();

    if (!reason) {
      alert("Please enter a reason.");
      return;
    }

    if (reason.length > 500) {
      alert("Reason must be under 500 characters.");
      return;
    }

    $.ajax({
      url: APP_URL + `/api/update/reason`,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({ image_id: editingImageId, reason: reason }),
      success: function () {
        $(`tr[data-id="${editingImageId}"] .discard-comment`).text(reason);
        $('#hideModal').hide();
        alert("Comment updated successfully.");
        editingImageId = null;
      },
      error: function () {
        alert("Failed to update comment.");
      }
    });
  });

  // Cancel modal
  $('#cancelHide').on('click', function () {
    $('#hideModal').hide();
    editingImageId = null;
  });

  // Delete
  $(document).on('click', '.delete-discard', function () {
    const id = $(this).data("id");
    if (!confirm("Are you sure you want to delete this discarded image?")) return;

    $.ajax({
      url: APP_URL + `/api/remove/discard/${id}`,
      method: "GET",
      success: function () {
        alert("Discarded image deleted.");
        fetchDiscardedImages(currentPage);
      },
      error: function () {
        alert("Failed to delete image.");
      }
    });
  });

  $('#hideComment').on('paste', function (e) {
    const pastedData = (e.originalEvent || e).clipboardData.getData('text');
    const currentLength = $(this).val().length;

    if ((currentLength + pastedData.length) > 500) {
      e.preventDefault();
      $('#reasonError').show();
    }
  });

  $('#hideComment').on('input', function () {
    const maxLength = 500;
    const currentLength = $(this).val().length;

    if (currentLength >= maxLength) {
      $('#reasonError').show();
    } else {
      $('#reasonError').hide();
    }
  });
});
